import React, {useEffect , useState} from 'react';

import { makeStyles } from '@material-ui/styles';
import { Hidden, Typography } from '@material-ui/core';
import { connect } from 'react-redux';
import { NavLink, useHistory } from 'react-router-dom';


import Drawer from '@material-ui/core/Drawer';
import IconButton from '@material-ui/core/IconButton';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import { Divider } from '@material-ui/core';
import YouTubeIcon from '@material-ui/icons/YouTube';
import FacebookIcon from '@material-ui/icons/Facebook';
import MenuIcon from '@material-ui/icons/Menu';
import CloseIcon from '@material-ui/icons/Close';
import config from '../../helpers/config';

const useStyles = makeStyles(theme => ({
    menuIconCurtain: {
        // position: 'fixed',
        // bottom: '50px',
        // right: '25px',
        // zIndex: 99

        textAlign: 'right',

        '& button': {
            color: theme.palette.primary.main
        }
    },
    paper: {
        width: '300px',
        paddingLeft: '20px',

        '& .media': {
            // position: 'absolute',
            // bottom: '0px', 
            width: '300px',
            padding: '25px 0px',

            '& a': {

                float: 'left',
                '& svg': {
                    height: '60px',
                    width: '70px',
    
                    '&.facebook': {
                        color: '#3b5998'
                    },
                    '&.youtube': {
                        color: '#c4302b'
                    },
                },
                
                '& .line': {
                    backgroundImage: `url(${config.S3Endpoint}/line.svg)`,
                    backgroundSize: '70%',
                    backgroundRepeat: 'no-repeat',
                    backgroundPosition: 'center',
                    height: '60px',
                    width: '70px'
                }

            }
        }
    },

    root: {
        width: '100vw',
        height: '100vh',
        transform: 'translateZ(1px)'
    },

    listRoot: {
        paddingTop: '70px',
        // height: 'calc(100vh - 170px)',
        overflow: 'auto'
    },

    logo: {
        display: 'block',
        height: '75px',
        width: '248px',
        backgroundImage: `url(${config.S3Endpoint}/header/logo-thumbnail.png)`,
        backgroundSize: 'contain',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat'
    },

    navLink: {
        textDecoration: 'none',
        color: theme.palette.text.primary,
        fontWeight: '400',
        letterSpacing: '5',
        textShadow: '1px 1px 4px #ececec',

        '&.selected': {            
            color: theme.palette.text.secondary,
        }
    },

    selected: {
        fontWeight: '400'
    },

    closeMenu: {
        position: 'absolute',
        right: '10px',
        top: '13.5px',
        color: theme.palette.primary.main,
        cursor: 'pointer'
    }


}));

const MobileMenuIcon = ({headers}) => {

    if (!headers || headers.length === 0) {
        return <div></div>
    }

    const classes = useStyles();
    const history = useHistory();
    const [open, setOpen] = React.useState(false);

    const toggleDrawer = (open) => (event) => {
        console.log(open);
        if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
            return;
        }
        setOpen(open);
    };

    const handleClick = (link) => {
        if (history) {
            history.push(link);
        }
    }

    const list = () => (
        <div role="presentation" onClick={toggleDrawer(false)} onKeyDown={toggleDrawer(false)} className={classes.drawer}>
            
            <List classes={{root: classes.listRoot}}>
                <ListItem button onClick={() => handleClick('/')}>
                    <ListItemText primary={<Typography><NavLink to="/" className={classes.logo}></NavLink></Typography>}/>
                </ListItem> 
                {headers.map((d, i) => {
                    if (d.disabled) {
                        return;
                    }
                    var link = d.internal ? 
                        (<NavLink className={classes.navLink} to={d.linkUrl} target={d.linkTarget} activeClassName="selected">{d.name}</NavLink>) : 
                        (<a className={classes.navLink} rel="noopener" href={d.linkUrl} target={d.linkTarget}>{d.name}</a>)
                    return (
                        <React.Fragment key={d.id}>
                            <ListItem button  onClick={() => handleClick(d.linkUrl)}>
                                <ListItemText primary={<Typography variant="h5" display="inline" align="center" >{link}</Typography>} />
                            </ListItem> 
                        </React.Fragment>
                    )
                })}
                {/* <ListItem button onClick={() => handleClick('/contact')}>
                    <ListItemText primary={<Typography variant="h5" display="inline" align="center" ><NavLink to="/contact" className={classes.navLink} activeClassName="selected">聯絡我們</NavLink></Typography>}/>
                </ListItem>  */}
            </List>
            <IconButton children={<CloseIcon />} onClick={toggleDrawer(false)} className={classes.closeMenu} />
            <div className="media">
                <a target="_blank" href="https://www.facebook.com/mibaoservice"><FacebookIcon className="facebook"/></a>
                <a target="_blank" href="https://www.youtube.com/channel/UCVFJ1W4zYl2SgOO3t_eV07g?view_as=subscriber"><YouTubeIcon className="youtube"/></a>
            </div>
        </div>
    );

    headers = headers || [];
    return(
        <React.Fragment>
            <div className={classes.menuIconCurtain}>
                <IconButton children={<MenuIcon />} onClick={toggleDrawer(true)} />
                {/* <Button variant="contained" onClick={toggleDrawer(true)} className={classes.menu}><MenuIcon /></Button> */}
                <Drawer anchor={'right'} classes={{root: classes.root, paper: classes.paper}} open={open} onClose={toggleDrawer(false)}>
                    {list()}
                </Drawer>
            </div>
        </React.Fragment>
    )
};

const MobileMenuDrawer = (props) => {
    const classes = useStyles(props),
        {auth} = props;
    return <React.Fragment>
        <Hidden mdUp={true} implementation="css">
            <MobileMenuIcon {...auth}/>
        </Hidden>
    </React.Fragment>
}

function mapStateToProps({ auth }) {
    return { auth };
}

export default connect(mapStateToProps)(MobileMenuDrawer);


// WEBPACK FOOTER //
// ./src/client/components/MobileMenuDrawer.js